import React from 'react';
// import {Redirect} from 'react-router'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import CacheBuster from './utils/cacheBuster';

//components for routing
import Home from './components/screens/Home';
import Sites from './components/screens/Sites';
import SiteCanvasses from './components/screens/SiteCanvasses';
import Canvassers from './components/screens/Canvassers';
import Admin from './components/screens/Admin';
import CreateSite from './components/screens/CreateSite';
import Scripts from './components/screens/Scripts';
import MapReports from './components/screens/MapReports';
import RouteEdit from './components/screens/RouteEdit';
import Schedule from './components/screens/Schedule';
import SimpleSiteRouteEdit from './components/screens/SimpeSiteRouteEdit';
import Login from './components/screens/Login';
import CampaignSelect from './components/screens/CampaignSelectScreen';
import SiteRoutesScreen from './components/screens/SiteRoutesScreen';
import AccessDenied from './components/screens/AccessDenied';
import Profile from './components/screens/Profile';
import DoorSchedule from './components/screens/DoorSchedule';
import TurfCutter from './components/screens/TurfCutter';
import DoorCrewSheet from './components/screens/DoorCrewSheet';
import SiteCrewSheet from './components/screens/SiteCrewSheet';
import DoorCanvassStatusReport from './components/screens/DoorCanvassStatusReport';
import ScriptResponses from './components/theme/dashboard/charts/ScriptResponses';
import TrackerMap from './components/screens/TrackerMap2';
import SitesMap from './components/screens/SitesMap';
import ScriptEdit from './components/screens/ScriptEdit';
import DoorsUpload from './components/screens/DoorsUpload';

//global css imports
import '../node_modules/milligram/dist/milligram.css';
import './App.scss';
import OverviewScreen from './components/screens/OverviewScreen';
import DoorCanvassScreen from './components/screens/DoorCanvassScreen';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

const is_admin = () => {
  let state = store.getState();
  return state.permissions && state.permissions.is_admin;
};

const has_valid_token = () => {
  let state = store.getState();
  const refreshToken = state.session.refreshToken;

  const is_expired = () => {
    try {
      let exp = JSON.parse(window.atob(refreshToken.split('.')[1])).exp * 1000;
      let expDate = new Date(exp);
      return expDate < Date.now();
    } catch (e) {
      console.error(e);
      return false; // don't break the site because this doesn't work. We'll just get a screen flash and 403 error will log user out if token not valid.
    }
  };

  return !!state.session.refreshToken && !is_expired();
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      is_admin() === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const LoadMaskRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      has_valid_token() === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

class App extends React.Component {
  componentDidMount() {
    const state = store.getState();
    // ReactGA.initialize('UA-167739174-1',
    // 	{
    // 		gaOptions: {
    // 			cookieFlags: 'SameSite=None;Secure'
    // 		}
    // 	}
    // );

    // set app version here for cache busting
  }

  render() {
    return (
      <Router>
        <CacheBuster />
        <Provider store={store}>
          {/*<ErrorBoundary>*/}
          <PersistGate loading={null} persistor={persistor}>
            {/*<HistoryListener/>*/}
            <div className="App">
              <Switch>
                <LoadMaskRoute exact path="/" component={() => <Redirect to={'/dash'} />} />
                <LoadMaskRoute path="/map" component={TrackerMap} />
                <LoadMaskRoute path="/site" component={SitesMap} />
                <LoadMaskRoute path="/site-list" component={Sites} />
                <LoadMaskRoute path="/canvasser" component={Canvassers} />
                <PrivateRoute path="/admin" component={Admin} />
                <Route path="/create-site" component={CreateSite} />
                <LoadMaskRoute path="/map-report" component={MapReports} />
                <PrivateRoute exact path="/script" component={Scripts} />
                <LoadMaskRoute path="/dash/script-responses" component={ScriptResponses} />
                <LoadMaskRoute path="/script/:script_id/edit" component={ScriptEdit} />
                <Route path="/login" component={Login} />
                <Route path="/select-campaign" component={CampaignSelect} />
                <LoadMaskRoute exact path="/sitecanvass" component={SiteCanvasses} />
                <LoadMaskRoute
                  exact
                  path="/sitecanvass/:sitecanvass_id"
                  component={SiteRoutesScreen}
                />
                <LoadMaskRoute path="/sitecanvass/:sitecanvass_id/edit" component={RouteEdit} />
                <LoadMaskRoute
                  path="/sitecanvass/:sitecanvass_id/quickedit"
                  component={SimpleSiteRouteEdit}
                />
                <LoadMaskRoute path="/sitecanvass/:sitecanvass_id/schedule" component={Schedule} />
                {/*<LoadMaskRoute path="/sitecanvass/:sitecanvass_id/alerts" component={AlertsScreen} />*/}
                <LoadMaskRoute exact path="/doorcanvass" component={DoorCanvassScreen} />
                <LoadMaskRoute
                  path="/doorcanvass/:doorcanvass_id/schedule"
                  component={DoorSchedule}
                />
                <LoadMaskRoute
                  exact
                  path="/turfcutter/:doorcanvass_pass_id"
                  component={TurfCutter}
                />
                <Route path="/accessdenied" component={AccessDenied} />
                <Route path="/profile" component={Profile} />
                <Route path="/site-crewsheet/:shift" component={SiteCrewSheet} />
                <Route path="/door-crewsheet/:shift" component={DoorCrewSheet} />
                <LoadMaskRoute exact path="/dash" component={Home} />
                <LoadMaskRoute path="/dash/schedule-overview" component={OverviewScreen} />
                <LoadMaskRoute path="/dash/door-statuses" component={DoorCanvassStatusReport} />
                <Route path="/doors-upload" component={DoorsUpload} />
              </Switch>
            </div>
          </PersistGate>
          {/*</ErrorBoundary>*/}
        </Provider>
      </Router>
    );
  }
}

export default App;
